export var WithdrawDetailType;
(function (WithdrawDetailType) {
    WithdrawDetailType[WithdrawDetailType["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    WithdrawDetailType[WithdrawDetailType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    WithdrawDetailType[WithdrawDetailType["THIRD_PARTY_REQUEST_FAIL"] = 3] = "THIRD_PARTY_REQUEST_FAIL";
    WithdrawDetailType[WithdrawDetailType["FAIL"] = 4] = "FAIL";
})(WithdrawDetailType || (WithdrawDetailType = {}));
//# sourceMappingURL=WithdrawDetailType.js.map